import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import WelcomeScreen from './WelcomeScreen';
import ConsentScreen from './ConsentScreen';
import LandingPage from './LandingPage';
import HomePage from './HomePage';
import ResponsePage from './ResponsePage';
import WarmupScreen from './WarmupScreen';
import CalibrationScreen from './CalibrationScreen';
import IntroScreen from './IntroScreen';
import ConfigPage from './ConfigPage';
import ConversationListenScreen from './ConversationListenScreen';
import ConversationResponseScreen from './ConversationResponseScreen';
import FreeResponseScreen from './FreeResponseScreen';
import TipsScreen from './TipsScreen';
import { GazeConfigProvider } from './GazeConfigContext';
import './App.css';

// Wrapper that forces ResponsePage to remount when :id changes,
// so state (selectedId) resets properly when navigating between levels.
function ResponsePageWrapper() {
  const { id } = useParams();
  return <ResponsePage key={id} />;
}

function App() {
  // Trigger Chrome's async voice loading at app startup so voices are ready
  // by the time the user enables read-aloud in settings. Without this,
  // getVoices() returns [] at toggle time and the primer utterance never plays,
  // leaving speech synthesis permanently blocked.
  useEffect(() => {
    if (!window.speechSynthesis) return;
    window.speechSynthesis.getVoices();
    window.speechSynthesis.onvoiceschanged = () => {
      window.speechSynthesis.onvoiceschanged = null;
    };
  }, []);

  return (
    // GazeConfigProvider wraps all routes so any screen can read or update
    // the session configuration via useGazeConfig(). State resets on page load.
    <GazeConfigProvider>
      <Router>
        <Routes>
          <Route path="/" element={<WelcomeScreen />} />
          <Route path="/consent" element={<ConsentScreen />} />
          <Route path="/intro" element={<IntroScreen />} />
          <Route path="/landing" element={<LandingPage />} />
          <Route path="/warmup" element={<WarmupScreen />} />
          <Route path="/calibration" element={<CalibrationScreen />} />
          <Route path="/config" element={<ConfigPage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/response/:id" element={<ResponsePageWrapper />} />
          <Route path="/conversation/listen" element={<ConversationListenScreen />} />
          <Route path="/conversation/respond" element={<ConversationResponseScreen />} />
          <Route path="/free-response/:id" element={<FreeResponseScreen />} />
          <Route path="/tips" element={<TipsScreen />} />
        </Routes>
      </Router>
    </GazeConfigProvider>
  );
}

export default App;